import { ArrowForward } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import { isNonPermittedRoute, isUrlFromAoDescription, isUrlFromCompleterProfile, isUrlWorthWhiteBackground } from '../../Utils/utils';
import NavbarGlobal from '../shared/Navbar/NavbarGlobal';
import SideNavbar from '../shared/SideBar/SideNavbar';

const LayoutConnected = () => {
    const { pathname ,state} = useLocation();
    const { auth } = useAuth();
    // const currentUserStep=useStep();
    const currentUserStep = auth.completeStep;

    const role = useRole();
    const navigate = useNavigate();
    const [isEnteredToAODetails,setIsEnteredToAODetails] = useState(false);
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes
    // Outlet represent all  the children of layout component

    const RedirectToCompleteProfile = (actionChosenByTheUser = false) => {
        //  * LOGIC to fill
        // If we was from Home, going to a new NonPermitted route => to the right Complete Step
        // If we was Inside CompleteStep going to a permitted route => OK
        // ! to ADD : see I f he validate email code OR NOT, otherwise send him to validation page [TO CREATE LATER]
        //? let Say 5 is max steps
        if (state?.isFromRegister) navigate('/welcomeCompletion');
        else if (currentUserStep < 5) {
            // alert(currentUserStep, pathname , auth , role);
            if (isNonPermittedRoute(pathname, role) || actionChosenByTheUser) {
                const commonCompleteProfilePath = `/${role}/completeProfile`;
                if (role == 'expert') {
                    if( isUrlFromAoDescription(pathname)){
                        //* Scenario: msg alerte is hidden by default ( alerte orange)
                        // aoByDescription ne doit pas renvoyer l expert a completer profile => mais pltot afficher msg alerte
                        setIsEnteredToAODetails(true);
                        navigate(`${role}`);
                    }
                    else {
                        setIsEnteredToAODetails(false);
                        if (currentUserStep === 0)
                            navigate(`${commonCompleteProfilePath}/stepsToFollow`);
                        if (currentUserStep === 1)
                            navigate(`${commonCompleteProfilePath}`);
                        else if (currentUserStep === 2)
                            navigate(`${commonCompleteProfilePath}/step2`);
                        else if (currentUserStep === 3)
                            navigate(`${commonCompleteProfilePath}/step3`);
                        else if (currentUserStep === 4)
                            navigate(`${commonCompleteProfilePath}/step4`);
                    }
                }
            }
        }
    };

    useEffect(() => {
        if(currentUserStep!= null && pathname && auth && role){
            // alert(currentUserStep, pathname , auth , role);
            RedirectToCompleteProfile();
        }
    }, [pathname, currentUserStep, auth, role]);

    return (
        <div className="App">
            {!isUrlFromCompleterProfile(pathname) &&
                <SideNavbar />
            }
            <div
                style={{display:'flex',flexDirection:'column',gap:'25px',alignItems:'center',width:'100%',
                    paddingLeft: isUrlFromCompleterProfile(pathname) ? '0px': '24px',
                    paddingBottom: isUrlFromCompleterProfile(pathname)?'0px': '24px',
                    //paddingBottom:'24px',
                    paddingTop: '8px',
                    paddingRight: isUrlFromCompleterProfile(pathname)?'0px': '24px',
                    overflow:'auto',
                    //background:'#F5F6FA',
                    background:isUrlWorthWhiteBackground(pathname) ? 'white' : '#F5F6FA',
                    height: (pathname.includes('stepsToFollow') || device!='desktop')? '100%' : 'auto',
                }}
            >
                <NavbarGlobal />
                {currentUserStep < 5 && !isUrlFromCompleterProfile(pathname)
                    && (role == 'expert')
                    && isEnteredToAODetails
                    && <Alert severity="error">
                        {i18n.t('Nous vous invitons à compléter votre profil,')}
                        {i18n.t('pour pouvoir postuler aux appels d\'offres')}
                        <IconButton
                            contained
                            sx={{ color: '#272D3C', padding: '0px' }}
                            onClick={() =>
                                RedirectToCompleteProfile(true)
                            }
                        >
                            <ArrowForward />
                        </IconButton>
                    </Alert>
                }
                <Outlet />
            </div>
        </div>
    );
};

export default LayoutConnected;